import { axiosInstance } from "@src/api/axiosConfig";
import { axiosPath } from "@src/api/axiosPath";
import { useMutation, useQuery, useQueryClient } from "react-query";

const getExpertApprovalList = async (params: getExpertApprovalListParams) => {
    const response = await axiosInstance.get<getExpertApprovalListResponse>(axiosPath.userExpertApprovalList, {
        params,
    });
    return response.data;
};

const useExpertApprovalList = (params: getExpertApprovalListParams) => {
    return useQuery({
        queryKey: ["expertApprovalList"],
        queryFn: () => getExpertApprovalList(params),
        enabled: false,
    });
};

export default useExpertApprovalList;

type ExpertApprovalItem = {
    id: string;
    name: string;
    phone: string;
    type: string;
    categories: string[];
    status: string;
    expertNo: number;
    expertUserNo: number;
};

type getExpertApprovalListResponse = {
    expertApprovalList: ExpertApprovalItem[];
};

export type ExpertApprovalType = "경매대행" | "경매대행매물컨설팅" | "임장동행";
// export type SettlementStatus = "지급예정" | "지급완료";
// export type ConfirmStatus = "의뢰인 확인 완료" | "의뢰인 확인 대기중";

export type getExpertApprovalListParams = {
    page: number;
    limit: number;
    cursor: string;
    type: ExpertApprovalType[];
    searchStartDate: string;
    searchEndDate: string;
    searchKeyword: string;
    searchType: string;
};

// 1: 대기중 2: 지급예정 200: 지급완료 500:에러

export type getExpertSettlementListParams = {
    page: number;
    limit: number;
    cursor?: string;
    type?: ExpertApprovalType[];
    payoutStatus?: number;
    userCheck?: boolean;
    searchStartDate?: string;
    searchEndDate?: string;
    searchValue?: string;
    searchType?: string;
};
// 전문가 승인 요청 타입
const updateExpertApproval = async (params: { expertUserNoList: number[] }) => {
    const response = await axiosInstance.patch(axiosPath.userExpertAuctionAgent, params);
    return response.data;
};

export const useUpdateExpertApproval = () => {
    return useMutation({
        mutationFn: (params: { expertUserNoList: number[] }) => updateExpertApproval(params),
    });
};

type getExpertSettlementListResponse = {
    list: ExpertSettlementItem[];
};

type ExpertSettlementItem = {
    no: number;
    settledMonth: string;
    name: string;
    phone: string;
    subId: string;
    itemId: string;
    totalAmount: string;
    feeAmount: string;
    netAmount: string;
    payExpectAt: string;
    userChecked: string;
    status: string;
    expertName: string;
    expertPhone: string;
};

const getExpertSettlementList = async (params: getExpertSettlementListParams) => {
    const response = await axiosInstance.get<getExpertSettlementListResponse>(axiosPath.expertSettlementList, {
        params,
    });
    return response.data;
};

export const useExpertSettlementList = (params: getExpertSettlementListParams) => {
    return useQuery({
        queryKey: ["expertSettlementList"],
        queryFn: () => getExpertSettlementList(params),
        enabled: false,
    });
};

const payOutExpertSettlement = async (settlementLedgerNo: number) => {
    const response = await axiosInstance.post(axiosPath.expertSettlementList, undefined, {
        params: {
            settlementLedgerNo,
        },
    });
    return response.data;
};

export const usePayOutExpertSettlement = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (settlementLedgerNo: number) => payOutExpertSettlement(settlementLedgerNo),
        onSuccess: () => {
            queryClient.invalidateQueries(["expertSettlementList"]);
        },
    });
};
